<template>
  <Header />
  <SideBar />
  <div class="app-content">
    <div class="nav">
      <nav>
        <router-link :to="{ name: 'home' }">Home</router-link>
        <router-link :to="{ name: 'about' }">About</router-link>
        <router-link :to="{ name: 'certificates' }">Certificates</router-link>
        <router-link :to="{ name: 'works' }">Works</router-link>
        <router-link :to="{ name: 'contact' }">Contact</router-link>
      </nav>
    </div>
    <main id="main_container">
      <router-view v-slot="{ Component, route }">
        <transition
          :enter-active-class="route.meta.enterCLass"
          :leave-active-class="route.meta.leaveClass"
          mode="out-in"
        >
          <component :is="Component" />
        </transition>
      </router-view>
    </main>
  </div>
</template>
<script setup>
import Header from "./components/Header.vue";
import SideBar from "./components/SideBar.vue";
var Tawk_API = Tawk_API || {},
  Tawk_LoadStart = new Date();
(function () {
  var s1 = document.createElement("script"),
    s0 = document.getElementsByTagName("script")[0];
  s1.async = true;
  s1.src = "https://embed.tawk.to/65aeb29d8d261e1b5f567b65/1hkp6jdqn";
  s1.charset = "UTF-8";
  s1.setAttribute("crossorigin", "*");
  s0.parentNode.insertBefore(s1, s0);
})();
</script>
<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
:root {
  --skin-color: #c1a162;
  --blue-color: #0f748fb3;
  --active-color: #fa0;
  --dark-color: #19283f;
  --bg-black-900: #191919;
  --bg-black-950: #181818;
  --bg-black-100: #212123;
  --bg-black-50: #222;
  --text-black-900: #ffffff;
  --text-black-700: #e9e9e9;
  --text-black-400: #777;
  --text-black-100: #333;
  --color: #9176ff;
  --dark-color: #2b2b2b;
  --dark-icon-color: #fff;
  --light-color: #f7f7f7;
  --light-icon-color: #fff;
}
body {
  background: var(--bg-black-900) !important;
}
body.light {
  --bg-black-900: #f2f2fc;
  --bg-black-100: #fdf9ff;
  --bg-black-50: #fdf9ffbf;
  --bg-black-950: #fdf9ff;
  --text-black-400: #b4b2b2;
  --text-black-100: #b4b2b2ad;
  --light-icon-color: #ffde59;

  --text-black-900: #302e4d;
  --text-black-700: #504e70;
}
.app-content {
  display: flex;
  width: 100%;
  height: calc(100vh - 112px);
  align-items: center;
  .nav {
    width: 250px;
    display: grid;
    place-content: center;

    @media (max-width: 768px) {
      display: none;
    }
    nav {
      position: relative;
      display: flex;
      flex-direction: column;
      gap: 50px;
      font-size: 1.2rem;
      padding: 10px;
      &::before {
        content: "";
        width: 1px;
        height: 100%;
        background: var(--text-black-900);
        position: absolute;
        left: -52px;
        top: 0;
      }
      a {
        text-decoration: none;
        color: var(--text-black-900);
        position: relative;
        &::before {
          content: "";
          position: absolute;
          width: 10px;
          height: 10px;
          border-radius: 50px;
          left: -67px;
          top: 4px;
          background: var(--text-black-900);
        }
        &.router-link-exact-active {
          color: #fa0;
          &::after {
            content: "";
            width: 20px;
            height: 20px;
            border: 2px solid var(--active-color);
            border-radius: 50px;
            position: absolute;
            left: -72px;
            top: -1px;
          }
          &::before {
            background: var(--active-color);
          }
        }
      }
    }
  }
  main {
    flex: 1 1 0;
    min-height: calc(100vh - 109px);
    max-height: calc(100vh - 110px);
    overflow-y: auto;
    overflow-x: hidden;
    &::-webkit-scrollbar {
      width: 5px;
      height: 12px;
    }
    &::-webkit-scrollbar-thumb {
      background: var(--skin-color);
      border-radius: 20px;
    }
  }
}

@media (max-width: 1253px) {
  .contact .contact-info-item {
    flex: 0 0 50% !important;
    max-width: 50% !important;
  }
}

@media (max-width: 767px) {
  .contact .contact-form .col-6,
  .contact .contact-info-item,
  .work .portfolio-item,
  .services .services-item {
    flex: 0 0 100% !important;
    max-width: 100% !important;
  }
  .portfolio .portfolio-item .portfolio-img,
  .portfolio-img img {
    height: 300px !important;
  }
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease-out;
}
</style>
